import { AxiosResponse } from "axios";
import { api } from "../library/axios";
import { API_ROUTE } from "../const/apiRoute";
import { NotificationExtension } from "../_base/extension/NotificationExtension";
import { HanderResponse } from "../_base/helper/FunctionHelper";
import { isNullOrUndefined } from "../_base/extension/StringExtension";
import { CategorySpecialModel } from "../model/CategorySpecial";

//List bộ sưu tập
export const getListCollection = async (query: string): Promise<any> => {
  try {
    // const response: AxiosResponse = await api.get(
    //   `${API_ROUTE.GET_LIST_COLLECTION}?${query}`
    // );
    const response: AxiosResponse = await api.get(
      `${API_ROUTE.GET_LIST_COLLECTION_NEW}?${query}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
//Chi tiết bộ sưu tập
export const getDetailCollection = async (query: string): Promise<any> => {
  try {
    // const response: AxiosResponse = await api.get(
    //   `${API_ROUTE.GET_LIST_COLLECTION}?${query}`
    // );
    const response: AxiosResponse = await api.get(
      `${API_ROUTE.DETAIL_COLLECTION_NEW}?${query}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Thêm mới bộ sưu tập
export const createCollection = async (
  data: CategorySpecialModel
): Promise<any> => {
  try {
    // const response: AxiosResponse = await api.post(
    //   API_ROUTE.CREATE_COLLECTION,
    //   data
    // );
    const response: AxiosResponse = await api.post(
      API_ROUTE.CREATE_COLLECTION_NEW,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Thêm mới bộ sưu tập thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Thêm mới bộ sưu tập thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

//CHỉnh sửa bộ sưu tập
export const editCollection = async (
  data: CategorySpecialModel
): Promise<any> => {
  try {
    // const response: AxiosResponse = await api.post(
    //   API_ROUTE.EDIT_COLLECTION,
    //   data
    // );
    const response: AxiosResponse = await api.post(
      API_ROUTE.EDIT_COLLECTION_NEW,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Sửa bộ sưu tập thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Sửa bộ sưu tập thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Xóa bộ sưu tập
export const deleteCollection = async (data: any): Promise<any> => {
  try {
    // const response: AxiosResponse = await api.post(
    //   API_ROUTE.DELETE_COLLECTION,
    //   data
    // );
    const response: AxiosResponse = await api.post(
      API_ROUTE.DELETE_COLLECTION_NEW,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Xoá bộ sưu tập thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Xoá bộ sưu tập thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Lấy danh sách sản phẩm trong bộ sưu tập
export const getDetailListItemCollection = async (
  query: string
): Promise<any> => {
  try {
    // const response: AxiosResponse = await api.get(
    //   `${API_ROUTE.GET_LIST_COLLECTION}?${query}`
    // );
    const response: AxiosResponse = await api.get(
      `${API_ROUTE.DETAIL_LIST_ITEM_COLLECTION_NEW}?${query}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Xóa sản phẩm trong bộ sưu tập
export const deleteItemCollection = async (data: any): Promise<any> => {
  try {
    // const response: AxiosResponse = await api.post(
    //   API_ROUTE.DELETE_COLLECTION,
    //   data
    // );
    const response: AxiosResponse = await api.post(
      API_ROUTE.DELETE_ITEM_COLLECTION_NEW,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success(
        "Xoá sản phẩm trong bộ sưu tập thành công !"
      );
    } else if (response != null)
      NotificationExtension.Fails("Xoá sản phẩm trong bộ sưu tập thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Xóa sản phẩm trong bộ sưu tập
export const addItemCollection = async (data: any): Promise<any> => {
  try {
    // const response: AxiosResponse = await api.post(
    //   API_ROUTE.DELETE_COLLECTION,
    //   data
    // );
    const response: AxiosResponse = await api.post(
      API_ROUTE.ADD_ITEM_COLLECTION_NEW,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success(
        "Thêm sản phẩm vào bộ sưu tập thành công !"
      );
    } else if (response != null)
      NotificationExtension.Fails("Thêm sản phẩm vào bộ sưu tập thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Xóa sản phẩm trong bộ sưu tập
export const editItemCollection = async (data: any): Promise<any> => {
  try {
    // const response: AxiosResponse = await api.post(
    //   API_ROUTE.DELETE_COLLECTION,
    //   data
    // );
    const response: AxiosResponse = await api.post(
      API_ROUTE.EDIT_ITEM_COLLECTION_NEW,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success(
        "Sửa sản phẩm trong bộ sưu tập thành công !"
      );
    } else if (response != null)
      NotificationExtension.Fails("Sửa sản phẩm trong bộ sưu tập thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
// Hàm cập nhật thêm sản phẩm trong bộ sưu tập
export const UpdatefilexcelSpecialProduct = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_FILEEXCEL_SPECIAL_PRODUCT,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Cập nhật thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const UpdatefilexcelCollectiopnFrame = async (
  data: any
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_FILEEXCEL_COLLECTION_FRAME,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Cập nhật thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
